import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home/Home.jsx';
import Races from './pages/Misc/evcars/Races.jsx/Races.jsx';
import Misc from './pages/Misc/Misc.jsx';
import Evcars from './pages/Misc/evcars/Evcars.jsx';
import About from './pages/About/About.jsx';
import Database from './pages/Misc/evcars/Database/Database.jsx';
import Header from './components/Header/Header.jsx';
import Login from './pages/Login/Login.jsx';
import SingleCar from './components/SingleCar/SingleCar.jsx';
import Minigames from './pages/Misc/Minigames/Minigames.jsx';
import Bingo from './pages/Misc/Minigames/Bingo/Bingo.jsx';
import Plates from './pages/Misc/Minigames/Plates/Plates.jsx';
import NotFound from './components/NotFound/NotFound.jsx';
import Profile from './pages/Profile/Profile.jsx';
import PartyFun from './pages/Misc/Minigames/PartyFun/PartyFun.jsx';
import PlayersSelector from './pages/Misc/Minigames/PartyFun/PlayersSelector.jsx';
import Metrics from './pages/Metrics/Metrics.jsx';
import Pitis from './pages/Metrics/Pitis/Pitis.jsx';
import GameCodeSelector from './pages/Misc/Minigames/GameCodeSelector.jsx';
import ChallengesForm from './pages/ChallengesForm/ChallengesForm.jsx';
import Challenges from './pages/ChallengesForm/Challenges.jsx';
import Require from './components/Require/Require.jsx';
import Rooms from './pages/Misc/Minigames/Rooms.jsx';
import Git from './pages/Git/Git.jsx';
import Telegram from './pages/Telegram/Telegram.jsx';
import Lists from './pages/Lists/Lists.jsx';
import List from './pages/List/List.jsx';

const AppRoutes = () => {

    return (
        <Router>
            <Header />
            <Routes>
                <Route path="/" element={<Home />} />

                <Route path="/misc/evcars/races" element={
                    <Require roles={['developer']}>
                        <Races />
                    </Require>
                } />

                <Route path="/misc" element={
                    <Require roles={[]}>
                        <Misc />
                    </Require>
                } />

                <Route path="/git" element={
                    <Require roles={['git']}>
                        <Git />
                    </Require>
                } />

                <Route path="/lists" element={
                    <Require roles={['lists']}>
                        <Lists />
                    </Require>
                } />

                <Route path="/lists/:listID" element={
                    <Require roles={['lists']}>
                        <List />
                    </Require>
                } />

                <Route path="/telegram" element={
                    <Require roles={['developer']}>
                        <Telegram />
                    </Require>
                } />

                <Route path="/misc/minigames" element={
                    <Require roles={['bingo']}>
                        <Minigames />
                    </Require>
                } />

                <Route path="/misc/minigames/:gameName" element={
                    <Require roles={[]}>
                        <GameCodeSelector />
                    </Require>
                } />


                <Route path="/misc/minigames/:gameName/rooms" element={
                    <Require roles={[]}>
                        <Rooms />
                    </Require>
                } />

                <Route path="/misc/minigames/:gameName/rooms/:roomNumber" element={
                    <Require roles={[]}>
                        <Bingo />
                    </Require>
                } />

                <Route path="/bingo/challenges/form" element={
                    <Require roles={[]}>
                        <ChallengesForm />
                    </Require>
                }/>

                <Route path="/bingo/challenges" element={
                    <Require roles={[]}>
                        <Challenges />
                    </Require>
                } />

                <Route path="/misc/minigames/plates" element={
                    <Require roles={['developer']}>
                        <Plates />
                    </Require>
                } />

                <Route path="/misc/minigames/partyfun" element={
                    <Require roles={['developer']}>
                        <PartyFun />
                    </Require>
                } />

                <Route path="/misc/minigames/partyfun/num-players" element={
                    <Require roles={['developer']}>
                        <PlayersSelector />
                    </Require>
                } />

                <Route path="/misc/evcars" element={
                    <Require roles={['developer']}>
                        <Evcars />
                    </Require>
                } />

                <Route path="/misc/evcars/database" element={
                    <Require roles={['developer']}>
                        <Database />
                    </Require>
                } />

                <Route path="/misc/evcars/database/:carId" element={
                    <Require roles={['developer']}>
                        <SingleCar />
                    </Require>
                } />

                <Route path="/metrics" element={
                    <Require roles={['developer']}>
                        <Metrics />
                    </Require>
                } />

                <Route path="/metrics/pitis" element={
                    <Require roles={['developer']}>
                        <Pitis />
                    </Require>
                } />

                <Route path="/about" element={
                    <Require roles={['developer']}>
                        <About />
                    </Require>
                } />

                <Route path="/login" element={<Login />} />

                <Route path="/profile" element={<Profile />} />

                <Route path="*" element={<NotFound />} /> 

            </Routes>
        </Router>
    );
};

export default AppRoutes;